import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=47842d02"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47842d02')) {
      api.createRecord('47842d02', component.options)
    } else {
      api.reload('47842d02', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=47842d02", function () {
      api.rerender('47842d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/accounts/Create.vue"
export default component.exports